const countDecimalPlaces = (num) => {
  if ((num % 1) !== 0) {
    return num.toString().split('.')[1].length
  } else {
    return 0
  }
}

export default countDecimalPlaces
